<template>
    <span class="sort-icon">
        <Icon 
            @click="handleSort('up')"
            :class="[sort=='up'?'on':'']" 
            type="md-arrow-dropup" />
        <Icon 
            @click="handleSort('down')"
            :class="[sort=='down'?'on':'']" 
            type="md-arrow-dropdown" />
    </span>
</template>

<script>
export default {
    name:'sort-icon',
    props:{
        sort:{
            type:String,
            default:'' //down降序 up升序
        }
    },
    methods:{
        handleSort(sort){
            this.$emit('select-sort',sort);
        }
    }
}
</script>

<style lang="less" scoped>
    .sort-icon{
        position: relative;
        display: inline-block;
        width: 14px;
        height: 12px;
        // margin-top: -1px;
        vertical-align: middle;
        // overflow: hidden;
        // cursor: pointer;
        // position: relative;

        i:first-child{
            position: absolute;
            bottom: 2px;
        }
        i:last-child{
            position: absolute;
            top:2px;
        }
        i.on{
            color: #1f6cdd;
        }
        i{
            display: inline-block;
            font-family: Ionicons;
            speak: none;
            font-style: normal;
            font-weight: 400;
            font-size: 14px;
            font-variant: normal;
            text-transform: none;
            text-rendering: auto;
            line-height: 1;
            color: #c5c8ce;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            vertical-align: middle;
            cursor: pointer;
            &:hover{
                color: #464C5B;
            }
        }
      
    }
</style>